import { HorizontalAlignment, LogManager, VerticalAlignment } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { Panel } from "../panel/Panel";
import { VendorMap } from "./Map";
import { MapPin } from "./MapPin";
import { VendorMapProps } from "./MapProps";
import { Label } from "../label/Label";

const log = LogManager.getLogger("components/Map");

export enum RouteType {
    None
}

export class NoMap extends Panel implements VendorMap {

    constructor(props?: Partial<VendorMapProps>) {
        super({ borderRadius: 4, ...props });
        const labelNoConfig = new Label({
            id: this.createInnerComponentId("labelNoConfig"),
            text: "Mapping not Configured",
            fillRow: true,
            fillHeight: true,
            imageProps: { name: ImageName.designer_map, height: 32, width: 32, color: "primary", align: HorizontalAlignment.LEFT },
            align: HorizontalAlignment.CENTER,
            verticalAlign: VerticalAlignment.CENTER,
            borderWidth: 1,
            borderRadius: 4,
            borderColor: "strokeSecondary",
            fontSize: "xxxlarge",
            fontBold: true,
            color: "primary"
        });
        this.add(labelNoConfig);
    }

    setCenter: (latitude: number, longitude: number) => void;
    getCenter: () => [number, number];
    addPin(pin: MapPin): void { }
    removeAllPins() { }
    focusOnPin: (pin: MapPin, mapPinIndex: number) => void;
    defocusOnPin: (pin: MapPin, mapPinIndex: number) => void;
    fitPins() { }
    setZoom(level: number) { }
    createRoute(routeData: any[], routeType: RouteType) { }
    createRouteFromCoordArray(routeData: any[], routetype?: any, hideMarkers?: boolean | false){}
    setStopZoomLevel: (isTrafficEnabled: string, routeData: any[]) => void;
    clearRoute() { }
    showCircle: (latitude: number, longitude: number, radius: number) => void;
    removeCircle: () => void;
    isStyleLoaded: () => boolean;
    onStyleLoad: (callback: () => void) => void;
}
